export const ALL_ITEM_WATCH_DISPLAY = [
    {
      categry: "watchDisplay",
      itemList: [
        {
          itemSelected: "isotta",
          itemName: "Isotta",
          itemDescription:
            "Isotta is our watch display made with high-quality materials and construction, and is designed to protect your watches from damage.",
          
            itemDescriptionList: [
              "Made in Thailand Craftsmanship",
              "Variety of World Class Materials",
              "Professional Consultation",
              "Fast Delivery",
            ],  itemDesktopBig: [
            "/images/listItem/watchDisplay/Istta/Desktop/700x700px/Lussopack-Packaging-Watch-Display-Isotta-01.webp",          
            "/images/listItem/watchDisplay/Istta/Desktop/700x700px/Lussopack-Packaging-Watch-Display-Isotta-02.webp",                 
          ],
          itemDesktopSmall: [
            "/images/listItem/watchDisplay/Istta/Desktop/130x130px/Lussopack-Packaging-Watch-Display-Isotta-01.webp",
            "/images/listItem/watchDisplay/Istta/Desktop/130x130px/Lussopack-Packaging-Watch-Display-Isotta-02.webp",
          ],
          itemMobileBig: [
            "/images/listItem/watchDisplay/Istta/Mobile/335x335px/Lussopack-Packaging-Watch-Display-Isotta-01.webp",
            "/images/listItem/watchDisplay/Istta/Mobile/335x335px/Lussopack-Packaging-Watch-Display-Isotta-02.webp",
          ],
          itemMobileSmall: [
            "/images/listItem/watchDisplay/Istta/Mobile/100x100px/Lussopack-Packaging-Watch-Display-Isotta-01.webp",
            "/images/listItem/watchDisplay/Istta/Mobile/100x100px/Lussopack-Packaging-Watch-Display-Isotta-02.webp",
          ],
        },
        {
          itemSelected: "matilde",
          itemName: "Matilde",
          itemDescription: "Matilde is our watch display that can be used to promote your brand and create a luxurious and inviting shopping experience for customers.",
          
          itemDescriptionList: [
            "Made in Thailand Craftsmanship",
            "Variety of World Class Materials",
            "Professional Consultation",
            "Fast Delivery",
          ],itemDesktopBig: [
            "/images/listItem/watchDisplay/Matilde/Desktop/700x700px/Lussopack-Packaging-Watch-Display-Matilde-01.webp",
            "/images/listItem/watchDisplay/Matilde/Desktop/700x700px/Lussopack-Packaging-Watch-Display-Matilde-02.webp"
          ],
          itemDesktopSmall: [
            "/images/listItem/watchDisplay/Matilde/Desktop/130x130px/Lussopack-Packaging-Watch-Display-Matilde-01.webp",
            "/images/listItem/watchDisplay/Matilde/Desktop/130x130px/Lussopack-Packaging-Watch-Display-Matilde-02.webp"
          ],
          itemMobileBig: [
            "/images/listItem/watchDisplay/Matilde/Mobile/335x335px/Lussopack-Packaging-Watch-Display-Matilde-01.webp",
            "/images/listItem/watchDisplay/Matilde/Mobile/335x335px/Lussopack-Packaging-Watch-Display-Matilde-02.webp"
          ],
          itemMobileSmall: [
            "/images/listItem/watchDisplay/Matilde/Mobile/100x100px/Lussopack-Packaging-Watch-Display-Matilde-01.webp",
            "/images/listItem/watchDisplay/Matilde/Mobile/100x100px/Lussopack-Packaging-Watch-Display-Matilde-02.webp"
          ]
        },
        {
          itemSelected: "torre",
          itemName: "Torre",
          itemDescription: "Torre is our watch display that allows customers to browse and view watches in a neat and organized way, making it easy to find the perfect watch to meet their needs.",
          
          itemDescriptionList: [
            "Made in Thailand Craftsmanship",
            "Variety of World Class Materials",
            "Professional Consultation",
            "Fast Delivery",
          ],itemDesktopBig: [
            "/images/listItem/watchDisplay/Torre/Desktop/700x700px/Lussopack-Packaging-Watch-Display-Torre-01.webp",
            "/images/listItem/watchDisplay/Torre/Desktop/700x700px/Lussopack-Packaging-Watch-Display-Torre-02.webp"
          ],
          itemDesktopSmall: [
            "/images/listItem/watchDisplay/Torre/Desktop/130x130px/Lussopack-Packaging-Watch-Display-Torre-01.webp",
            "/images/listItem/watchDisplay/Torre/Desktop/130x130px/Lussopack-Packaging-Watch-Display-Torre-02.webp"
          ],
          itemMobileBig: [
            "/images/listItem/watchDisplay/Torre/Mobile/335x335px/Lussopack-Packaging-Watch-Display-Torre-01.webp",
            "/images/listItem/watchDisplay/Torre/Mobile/335x335px/Lussopack-Packaging-Watch-Display-Torre-02.webp"
          ],
          itemMobileSmall: [
            "/images/listItem/watchDisplay/Torre/Mobile/100x100px/Lussopack-Packaging-Watch-Display-Torre-01.webp",
            "/images/listItem/watchDisplay/Torre/Mobile/100x100px/Lussopack-Packaging-Watch-Display-Torre-02.webp"
          ]
        }        
      ],
    },
  ];
  